var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-content"},[_c('h1',{staticClass:"not-found-title"},[_vm._v("404")]),_c('p',{staticClass:"not-found-text"},[_vm._v("抱歉，您暂无该页面访问权限，请联系管理员开通")])])])
}]

export { render, staticRenderFns }